export enum DomainState {
    Unspecified,
    NotCreated,
    Created,
    NotAuthenticated,
    Authenticated
}